import React from "react";
import PropTypes from "prop-types";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import "./DatePicker.scss";

/**
 * Data picker
 * @module
 * @param {string} name - Name
 * @param {func} onChange - Function invoked on value change
 * @param {Date | string} [value] - Current value
 * @param {bool} [disabled] - Is input readonly?
 * @param {bool} [required] - Is input required?
 * @param {string} [validationMessage] - Validation message if field is invalid
 * @param {Date | number} [min] - Minimum date
 * @param {Date | number} [max] - Maximum date
 * @param {number} [tabIndex] - Tabindex of datepicker
 * @param {string | object} [format] - Date format
 * @param {func} [onBlur] - Function invoked on input blur
 */

const DatePickerComponent = (props) => {
  const handleReset = async () => {
    await props.onChange(props.name, null);
    onBlur();
  };

  const handleToday = async () => {
    await props.onChange(props.name, new Date());
    onBlur();
  };

  const onBlur = () => {
    if (props.onBlur) {
      props.onBlur();
    }
  };

  let { value, min, max } = props;

  min =
    min && (typeof min === "number" || min instanceof Number)
      ? new Date(min)
      : undefined;
  max =
    max && (typeof max === "number" || max instanceof Number)
      ? new Date(max)
      : undefined;

  return (

    <div className={`form-input datepicker ${props.disabled ? "disabled-field" : props.required ? "required-field" : "default-field"}`}>
      <DatePicker
        onChange={(e) => props.onChange(props.name, e.target.value)}
        value={value}
        required={props.required}
        disabled={props.disabled}
        validationMessage={props.validationMessage || "Povinné"}
        min={min}
        max={max}
        tabIndex={props.tabIndex}
        format={props.format}
        onBlur={onBlur}
        placeholder={
          props.placeholder ||
          (props.disabled ? "" : "Zvoľte požadovaný dátum")
        }
      />
      <div
        className={`k-icon k-i-close datepicker-reset${(props.disabled || !value) ? "-disabled" : ""
          } ${!props.todayHidden ? "today" : ""}`}
        onClick={handleReset}
      />
      {!props.todayHidden && (
        <div
          className={`k-icon k-i-calendar-date datepicker-today${props.disabled ? "-disabled" : ""
            }`}
          onClick={handleToday}
        />
      )}
    </div>
  );
};

DatePickerComponent.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  todayHidden: PropTypes.bool,
  validationMessage: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  tabIndex: PropTypes.number,
  format: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onBlur: PropTypes.func,
};

export default DatePickerComponent;
